import Vue from "vue";
import Router from "vue-router";
import LoginActivity from "./components/activity/login/LoginActivity";
import HomeActivity from "./components/activity/home/HomeActivity";
import ClientDetailsActivity from "./components/activity/clientdetails/ClientDetailsActivity";
import LoanDetailsActivity from "./components/activity/loandetails/LoanDetailsActivity";
import AddressActivity from "./components/activity/AddressActivity";
import PermanentAddressActivity from "./components/activity/PermanentAddressActivity";
import CommunicationAddressActivity from "./components/activity/CommunicationAddressActivity";
import WorkAddressActivity from "./components/activity/WorkAddressActivity";
import PersonalDetailsActivity from "./components/activity/personaldetails/PersonalDetailsActivity";
import ProfessionalDetailsActivity
  from "./components/activity/professionaldetails/ProfessionalDetailsActivity";
import AdditionalProfessionalDetailsActivity
  from "./components/activity/professionaldetails/AdditionalProfessionalDetailsActivity";
import ChooseEmiActivity from "./components/activity/chooseemi/ChooseEmiActivity";
import BankDetailsActivity from "./components/activity/bankdetails/BankDetailsActivity";
import BankDetailsVerificationActivity
  from "./components/activity/bankdetailsverification/BankDetailsVerificationActivity";
import KycActivity from "./components/activity/kyc/KycActivity";
import SelfieActivity from "./components/activity/image/SelfieActivity";
import SignLenderDocumentActivity from "./components/activity/esign/SignLenderDocumentActivity";
import NachOptionsActivity from "./components/activity/nachOptions/NachOptionsActivity";
import SignEnachActivity from "./components/activity/enach/SignEnachActivity";
import NachActivity from "./components/activity/NachActivity";
import CustomerTasksCompletedActivity
  from "./components/activity/customertaskscompleted/CustomerTasksCompletedActivity";
import LenderTermsAndConditionsActivity
  from "./components/activity/lendertermsandconditions/LenderTermsAndConditionsActivity";
import BankStatementActivity from "./components/activity/bankstatement/BankStatementActivity";
import WaitActivity from "./components/activity/WaitActivity";
import PerfiosActivity from "./components/activity/perfios/PerfiosActivity";
import PerfiosSuccess from "./components/activity/perfios/PerfiosSuccess";
import DownpaymentActivity from "./components/activity/DownpaymentActivity";
import InvoiceActivity from "./components/activity/InvoiceActivity";
import LoanApprovedAmountActivity from "./components/activity/LoanApprovedAmountActivity";
import StudentDetails from "./components/activity/StudentDetails";
import CheckApprovalStatus from "./components/activity/CheckApprovalStatus";
import ChooseEmiDateActivity from "./components/activity/chooseemidate/ChooseEmiDateActivity";
import CustomerPhoneNumberActivity from "./components/activity/CustomerPhoneNumberActivity";
import LoanProductDetailsActivity from "./components/activity/LoanProductDetailsActivity";
import WelcomeActivity from "./components/activity/WelcomeActivity";
import LandingPage from "./components/activity/welcome/LandingPage";
import OfficeActivity from "./components/activity/OfficeActivity";
import KycOtpActivity from "./components/activity/KycOtpActivity";
import AdditionalDocumentsActivity from "./components/activity/AdditionalDocumentsActivity";
import CancelledChequeCollectionActivity
  from "./components/activity/CancelledChequeCollectionActivity";
import NachCollectionActivity from "./components/activity/NachCollectionActivity";
import GSTCopyActivity from "./components/activity/GSTCopyActivity";
import CancelledChequeActivity from "./components/activity/CancelledChequeActivity";
import AlternatePANActivity from "./components/activity/AlternatePANActivity";
import ResendSigningDocumentLinkActivity
  from "./components/activity/ResendSigningDocumentLinkActivity";
import ChooseBankAccountsActivity from "./components/activity/ChooseBankAccountsActivity";
import BankIdentifierActivity from "./components/activity/BankIdentifierActivity";
import AadhaarCardActivity from "./components/activity/AadhaarCardActivity";
import EMISchemeOptionActivity from "./components/activity/EMISchemeOptionActivity";
import AssetDetailsActivity from "./components/activity/AssetDetailsActivity";
import OrganizationDetailsActivity
  from "./components/activity/OrganizationDetailsActivity";
import HireVsBuyViabilityActivity
  from "@/components/activity/HireVsBuyViabilityActivity";
import FleetSummaryActivity from "./components/activity/FleetSummaryActivity";
import Form60DetailsActivity from "./components/activity/clientdetails/Form60DetailsActivity";
import FleetDetailsActivity from "@/components/activity/FleetDetailsActivity";
import Launch from "./index";
import BankOtpActivity from "./components/activity/BankOtpActivity";
import PanAddedActivity from "@/components/activity/PanAddedActivity";
import UploadPanActivity from "@/components/activity/image/UploadPanActivity";
import PanCardActivity from "@/components/activity/image/PanCardActivity";
import PanImageActivity from "@/components/activity/image/PanImageActivity";
import CoApplicantOrGuarantorActivity
  from "@/components/activity/CoApplicantOrGuarantorActivity";
import AssociatedEntitiesHomeActivity
  from "@/components/activity/AssociatedEntitiesHomeActivity";
import BureauDetailsActivity from "@/components/activity/BureauDetailsActivity";



Vue.use(Router);

export default new Router({
  routes: [
    /*
        {
          path: "/loandetails",
          name: "loandetails",
          component: LoanDetailsWithLogin
        },
        {
          path: "/otp?secretKey=:Secret",
          name: "otp",
          component: Otp
        },
        {
          path: "/toolbar",
          name: "toolbar",
          component: ToolBar
        },
        {
          path: "/phonenumber",
          name: "phonenumber",
          component: TakePhoneNumber
        },
        {
          path: "/emiactivity",
          name: "emiActivity",
          component: EmiActivity
        },
        */
    {
      path: "/",
      name: "launch",
      component: Launch
    },
    {
      path: "/login",
      name: "login",
      component: LoginActivity
    },
    {
      path: "/home",
      name: "home",
      component: HomeActivity
    },
    {
      path: "/clientDetails",
      name: "clientDetails",
      component: ClientDetailsActivity
    },
    {
      path: "/loan",
      name: "loan",
      component: LoanDetailsActivity
    },
    {
      path: "/address",
      name: "address",
      component: AddressActivity
    },
    {
      path: "/permanentAddress",
      name: "permanentAddress",
      component: PermanentAddressActivity
    },
    {
      path: "/communicationAddress",
      name: "communicationAddress",
      component: CommunicationAddressActivity
    },
    {
      path: "/workAddress",
      name: "workAddress",
      component: WorkAddressActivity
    },
    {
      path: "/personal",
      name: "personal",
      component: PersonalDetailsActivity
    },
    {
      path: "/professional",
      name: "professional",
      component: ProfessionalDetailsActivity
    },
    {
      path: "/professionalAdditional",
      name: "professionalAdditional",
      component: AdditionalProfessionalDetailsActivity
    },
    {
      path: "/emi",
      name: "emiScheme",
      component: ChooseEmiActivity
    },
    {
      path: "/bankDetails",
      name: "bankDetails",
      component: BankDetailsActivity
    },
    {
      path: "/bankDetailsVerification",
      name: "bankDetailsVerification",
      component: BankDetailsVerificationActivity
    },
    {
      path: "/kyc",
      name: "kyc",
      component: KycActivity
    },
    {
      path: "/kycForRetailer",
      name: "kycForRetailer",
      component: KycActivity
    },
    {
      path: "/selfie",
      name: "selfie",
      component: SelfieActivity
    },
    {
      path: "/T&C",
      name: "signLenderDocument",
      component: SignLenderDocumentActivity
    },
    {
      path: "/signT&C",
      name: "lenderTermsAndConditions",
      component: LenderTermsAndConditionsActivity
    },
    {
      path: "/nach",
      name: "nachOptions",
      component: NachOptionsActivity
    },
    {
      path: "/enach",
      name: "enach",
      component: SignEnachActivity
    },
    {
      path: "/nachForm",
      name: "nachForm",
      component: NachActivity
    },
    {
      path: "/customerTasksCompleted",
      name: "customerTasksCompleted",
      component: CustomerTasksCompletedActivity
    },
    {
      path: "/bankStatement",
      name: "bankStatement",
      component: BankStatementActivity
    },
    {
      path: "/perfios",
      name: "perfios",
      component: PerfiosActivity
    },
    {
      path: "/wait",
      name: "wait",
      component: WaitActivity
    },
    {
      path: "/downpayment",
      name: "downpayment",
      component: DownpaymentActivity
    },
    {
      path: "/invoice",
      name: "invoice",
      component: InvoiceActivity
    },
    {
      path: "/perfiosSuccess",
      name: "perfiosSuccess",
      component: PerfiosSuccess
    },
    {
      path: "/approvedAmount",
      name: "approvedAmount",
      component: LoanApprovedAmountActivity
    },
    {
      path: "/studentDetails",
      name: "studentDetails",
      component: StudentDetails
    },
    {
      path: "/approvalStatus",
      name: "approvalStatus",
      component: CheckApprovalStatus
    },
    {
      path: "/emiDate",
      name: "emiDate",
      component: ChooseEmiDateActivity
    },
    {
      path: "/customerPhoneNumber",
      name: "customerPhoneNumber",
      component: CustomerPhoneNumberActivity
    },
    {
      path: "/loanProductDetails",
      name: "loanProductDetails",
      component: LoanProductDetailsActivity
    },
    {
      path: "/welcome",
      name: "welcome",
      component: LandingPage
    },
    {
      path: "/office",
      name: "office",
      component: OfficeActivity
    },
    {
      path: "/kycOTPVerification",
      name: "kycOTPVerification",
      component: KycOtpActivity
    },
    {
      path: "/additionalDocuments",
      name: "additionalDocuments",
      component: AdditionalDocumentsActivity
    },
    {
      path: "/cancelledChequeCollection",
      name: "cancelledChequeCollection",
      component: CancelledChequeCollectionActivity
    },
    {
      path: "/nachCollection",
      name: "nachCollection",
      component: NachCollectionActivity
    },
    {
      path: "/gstCopy",
      name: "gstCopy",
      component: GSTCopyActivity
    },
    {
      path: "/cancelledCheque",
      name: "cancelledCheque",
      component: CancelledChequeActivity
    },
    {
      path: "/alternatePAN",
      name: "alternatePAN",
      component: AlternatePANActivity
    },
    {
      path: "/resendSigningDocumentLink",
      name: "resendSigningDocumentLink",
      component: ResendSigningDocumentLinkActivity
    },
    {
      path: "/bankAccounts",
      name: "bankAccounts",
      component: ChooseBankAccountsActivity
    },
    {
      path: "/bankIdentifierNumber",
      name: "bankIdentifierNumber",
      component: BankIdentifierActivity
    },
    {
      path: "/aadhaarCard",
      name: "aadhaarCard",
      component: AadhaarCardActivity
    },
    {
      path: "/emiSchemeOption",
      name: "emiSchemeOption",
      component: EMISchemeOptionActivity
    },
    {
      path: "/fleetSummary",
      name: "fleetSummary",
      component: FleetSummaryActivity
    },
    {
      path: "/assetDetails",
      name: "assetDetails",
      component: AssetDetailsActivity
    },
    {
      path: "/organizationDetails",
      name: "organizationDetails",
      component: OrganizationDetailsActivity
    },
    {
      path: "/hireVsBuyViability",
      name: "hireVsBuyViability",
      component: HireVsBuyViabilityActivity
    },
    {
      path: "/fleetDetails",
      name: "fleetDetails",
      component: FleetDetailsActivity
    },
    {
      path: "/form60",
      name: "form60",
      component: Form60DetailsActivity
    },
    {
      path: "/bankOtp",
      name: "bankOtp",
      component: BankOtpActivity
    },
    {
      path: "/panCard",
      name: "panCard",
      component: PanCardActivity
    },
    {
      path: "/panImage",
      name: "panImage",
      component: PanImageActivity
    },
    {
      path: "/associatedEntity",
      name: "associatedEntity",
      component: AssociatedEntitiesHomeActivity
    },
    {
      path: "/coApplicantsOrGuarantors",
      name: "coApplicantsOrGuarantors",
      component: CoApplicantOrGuarantorActivity
    },
    {
      path: "/bureauDetails",
      name: "bureauDetails",
      component: BureauDetailsActivity
    },
  ]
});
